module.exports = __webpack_public_path__ + "img/20210223_CellResearch.9fcc5b93.png";